import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
import { shadow2 } from '@/core/theme/shadows';
import { useState } from 'react';
import { InnerContainer } from './ActionTooltip.styled';
/**
 * This tooltip only rendered after the specified action is executed and removed from the DOM right after the specified delay.
 */
export const ActionTooltip = ({ closeDelay = 1000, color = 'default', copyToClipboardValue, children, ...rest }) => {
    const [renderTooltip, setRenderTooltip] = useState(false);
    const sxColor = color === 'success'
        ? ({ palette }) => ({
            color: palette.success.dark,
            backgroundColor: palette.success.background,
            boxShadow: shadow2,
        })
        : undefined;
    return (_jsx(InnerContainer, { onClick: (event) => {
            event.stopPropagation();
            if (!renderTooltip)
                setRenderTooltip(true);
            setTimeout(() => setRenderTooltip(false), closeDelay);
            if (copyToClipboardValue !== undefined) {
                navigator.clipboard.writeText(`${copyToClipboardValue}`);
            }
        }, children: renderTooltip ? (_jsx(Tooltip, { open: true, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, ...rest, slotProps: {
                popper: {
                    disablePortal: true,
                },
                tooltip: {
                    sx: sxColor,
                },
            }, children: children })) : (children) }));
};
